import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { LogService } from '../shared/log.service';
import { IdentityService } from '../identity/identity.service';
import { User } from './user.model';
import { RequestService } from './requests/request.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-identity',
  templateUrl: './identity.component.html',
  styleUrls: ['./identity.component.sass']
})
export class IdentityComponent implements OnInit {
  readonly isQrCodeModalVisible$ = this.identityService.isQrCodeModalVisible$;
  isRetrievingUser = false;
  currentUser?: User;
  rightView!: string;
  constructor(
    private authService: AuthService,
    private logger: LogService,
    private identityService: IdentityService,
    private requestService: RequestService
  ) { }

  ngOnInit(): void {
    this.authService.currentUserChanged.pipe()
      .subscribe((loggedUser: User) => {
        this.logger.log('ONINIT subscription');
        this.currentUser = loggedUser;
      });
    this.identityService.currentViewChanged.subscribe((data: string) => {
        this.rightView = data;
      });
    this.currentUser = this.authService.getCurrentUser();
    sessionStorage.setItem('username', this.currentUser.username);

    this.rightView = 'personalData';

    if (environment.showAuthenticationWithApp) {
      this.identityService.registerOnQrCodeModalVisibilityChange();
    }
  }

  onChooseAction(action: string): void{
    if (action){
      this.identityService.setCurrentView(action);
    }

  }

  changeView(viewName: string = 'personalData'): void {
    this.identityService.currentViewChanged.next(viewName);
  }

  canShowRequestButton(): boolean {
    return (this.requestService.hasStatusAllowed());
  }

  onCloseQrCodeModal(): void {
    this.identityService.qrCodeModalClosed = true;
  }
}
